"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var icon_1 = __importDefault(require("relements/build/esm/ui/icon"));
var button_1 = __importDefault(require("relements/build/esm/ui/button"));
var confirmationDialog_1 = __importDefault(require("relements/build/esm/decorators/confirmationDialog"));
var utils_1 = require("@src/utils");
var actions_1 = require("@src/containers/BusinessManager/store/actions");
var BotActions_1 = require("@src/actions/BotActions");
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
var constants_1 = require("../../constants");
var utils_2 = require("../../utils");
var maps_1 = require("./maps");
require("./Header.scss");
/**
 * Page Header for Business Manager
 * @component
 */
var Header = function (_a) {
    var activateConfirmationDialog = _a.activateConfirmationDialog;
    var _b = react_redux_1.useSelector(maps_1.stateToProps), businessId = _b.businessId, viaName = _b.viaName, activePartners = _b.activePartners;
    var handleTransferBusiness = react_1["default"].useCallback(function () {
        if (!businessId || !utils_2.canTransfer([constants_1.TRANSFER_TYPE.BUSINESS]))
            return;
        activateConfirmationDialog({
            title: "Do you want to publish this Business: " + viaName + "?",
            message: 'This Business will be published to Production.',
            positiveText: 'Publish',
            negativeText: 'Cancel',
            themed: true,
        }, function (success) { return __awaiter(void 0, void 0, void 0, function () {
            var headers, transferApiResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!success)
                            return [2 /*return*/];
                        headers = utils_2.getBusinessAuditHeaders(businessId, 'transfer_all_task', activePartners.map(function (partner) { return partner.name; }));
                        return [4 /*yield*/, actions_1.transferBusiness(businessId, headers)];
                    case 1:
                        transferApiResponse = _a.sent();
                        if (!transferApiResponse) {
                            BotActions_1.createAlert('Publish failed! Try again', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                            return [2 /*return*/];
                        }
                        BotActions_1.createAlert('Publish successful!', null, MogamboConstants_1.AlertTypes.POSITIVE);
                        return [2 /*return*/];
                }
            });
        }); });
    }, [businessId, activePartners, viaName]);
    return (react_1["default"].createElement("div", { className: "header" },
        react_1["default"].createElement("div", { className: "business" },
            "Business Manager",
            react_1["default"].createElement(icon_1["default"], { src: "arrow", size: icon_1["default"].SIZES.SMALL, className: "arrowIcon" }),
            react_1["default"].createElement("div", { className: "businessName" },
                react_1["default"].createElement("div", { className: "businessNameText" }, viaName))),
        !utils_1.isProduction() && (react_1["default"].createElement("div", { className: "transfer" },
            react_1["default"].createElement(button_1["default"], { onClick: handleTransferBusiness }, "Publish Business")))));
};
exports["default"] = confirmationDialog_1["default"]()(Header);
